import { obtenerCategoria } from '../notificaciones/categoriasNotificacion.js'

export const MAPA_NOTIFICACIONES = {
  categoriaNotificacion: {
    titulo: 'Tipo de notificación',
    opciones: ({ notificaciones = [], idUsuario }) => [
      ...new Map(
        notificaciones.map((n) => {
          const categoria = obtenerCategoria(n, idUsuario)
          return [categoria.id, { valor: categoria.id, label: categoria.etiqueta }]
        })
      ).values()
    ],
    filterFn: (n, valor, filtros) => obtenerCategoria(n, filtros.idUsuario).id === valor
  },

  textoBusqueda: {
    placeholder: 'Buscar en notificaciones...',
    filterFn: (n, v) => {
      const val = v.trim().toLowerCase()
      const idsEntidad = [n.idPedido, n.idPresupuesto, n.idPublicacion]
      return (
        (n.mensajeSistema || '').toLowerCase().includes(val) ||
        (n.titulo || '').toLowerCase().includes(val) ||
        (n.texto || '').toLowerCase().includes(val) ||
        idsEntidad.some((id) => id > 0 && String(id).includes(val))
      )
    }
  }
}
